var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SendEmail',{attrs:{"additional-props":_vm.additionalProps,"disabled":_vm.disabled,"value":_vm.valueMutable},on:{"update:value":function($event){_vm.valueMutable=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }